var map = {
	"./writingjapaneseanimal_100_optimized.jpg": "jIi+",
	"./writingjapaneseanimal_10_optimized.jpg": "Z8vd",
	"./writingjapaneseanimal_11_optimized.jpg": "vmuD",
	"./writingjapaneseanimal_12_optimized.jpg": "dYRc",
	"./writingjapaneseanimal_13_optimized.jpg": "IvkB",
	"./writingjapaneseanimal_14_optimized.jpg": "B8pe",
	"./writingjapaneseanimal_15_optimized.jpg": "chNU",
	"./writingjapaneseanimal_16_optimized.jpg": "IDcI",
	"./writingjapaneseanimal_17_optimized.jpg": "rmvz",
	"./writingjapaneseanimal_18_optimized.jpg": "V3Yd",
	"./writingjapaneseanimal_19_optimized.jpg": "kkQ3",
	"./writingjapaneseanimal_1_optimized.jpg": "5d+C",
	"./writingjapaneseanimal_20_optimized.jpg": "E2O4",
	"./writingjapaneseanimal_21_optimized.jpg": "KR0N",
	"./writingjapaneseanimal_22_optimized.jpg": "Wg4K",
	"./writingjapaneseanimal_23_optimized.jpg": "hBmQ",
	"./writingjapaneseanimal_24_optimized.jpg": "QSjf",
	"./writingjapaneseanimal_25_optimized.jpg": "LY+s",
	"./writingjapaneseanimal_26_optimized.jpg": "FHu1",
	"./writingjapaneseanimal_27_optimized.jpg": "JmKw",
	"./writingjapaneseanimal_28_optimized.jpg": "dDmH",
	"./writingjapaneseanimal_29_optimized.jpg": "5tWG",
	"./writingjapaneseanimal_2_optimized.jpg": "PwGs",
	"./writingjapaneseanimal_30_optimized.jpg": "ofcU",
	"./writingjapaneseanimal_31_optimized.jpg": "S8jF",
	"./writingjapaneseanimal_32_optimized.jpg": "QD3V",
	"./writingjapaneseanimal_33_optimized.jpg": "bCzN",
	"./writingjapaneseanimal_34_optimized.jpg": "V2Gh",
	"./writingjapaneseanimal_35_optimized.jpg": "E/z1",
	"./writingjapaneseanimal_36_optimized.jpg": "j36G",
	"./writingjapaneseanimal_37_optimized.jpg": "VKgD",
	"./writingjapaneseanimal_38_optimized.jpg": "hixm",
	"./writingjapaneseanimal_39_optimized.jpg": "3Qhm",
	"./writingjapaneseanimal_3_optimized.jpg": "NBjJ",
	"./writingjapaneseanimal_40_optimized.jpg": "Xwk3",
	"./writingjapaneseanimal_41_optimized.jpg": "vqc3",
	"./writingjapaneseanimal_42_optimized.jpg": "fo3B",
	"./writingjapaneseanimal_43_optimized.jpg": "ol4/",
	"./writingjapaneseanimal_44_optimized.jpg": "8YJ9",
	"./writingjapaneseanimal_45_optimized.jpg": "joAv",
	"./writingjapaneseanimal_46_optimized.jpg": "enBp",
	"./writingjapaneseanimal_47_optimized.jpg": "TYdc",
	"./writingjapaneseanimal_48_optimized.jpg": "kVQi",
	"./writingjapaneseanimal_49_optimized.jpg": "26h8",
	"./writingjapaneseanimal_4_optimized.jpg": "lsmj",
	"./writingjapaneseanimal_50_optimized.jpg": "/J4n",
	"./writingjapaneseanimal_51_optimized.jpg": "iI+e",
	"./writingjapaneseanimal_52_optimized.jpg": "nem0",
	"./writingjapaneseanimal_53_optimized.jpg": "vUQo",
	"./writingjapaneseanimal_54_optimized.jpg": "aDh8",
	"./writingjapaneseanimal_55_optimized.jpg": "9a/e",
	"./writingjapaneseanimal_56_optimized.jpg": "xDVb",
	"./writingjapaneseanimal_57_optimized.jpg": "jyvL",
	"./writingjapaneseanimal_58_optimized.jpg": "pGXd",
	"./writingjapaneseanimal_59_optimized.jpg": "asDj",
	"./writingjapaneseanimal_5_optimized.jpg": "q88U",
	"./writingjapaneseanimal_60_optimized.jpg": "nKxN",
	"./writingjapaneseanimal_61_optimized.jpg": "y7Yy",
	"./writingjapaneseanimal_62_optimized.jpg": "7SYC",
	"./writingjapaneseanimal_63_optimized.jpg": "MT5c",
	"./writingjapaneseanimal_64_optimized.jpg": "AggD",
	"./writingjapaneseanimal_65_optimized.jpg": "1xPT",
	"./writingjapaneseanimal_66_optimized.jpg": "RrLL",
	"./writingjapaneseanimal_67_optimized.jpg": "Fep8",
	"./writingjapaneseanimal_68_optimized.jpg": "eALj",
	"./writingjapaneseanimal_69_optimized.jpg": "ShZP",
	"./writingjapaneseanimal_6_optimized.jpg": "lG2T",
	"./writingjapaneseanimal_70_optimized.jpg": "An3m",
	"./writingjapaneseanimal_71_optimized.jpg": "yo5u",
	"./writingjapaneseanimal_72_optimized.jpg": "UzJy",
	"./writingjapaneseanimal_73_optimized.jpg": "Hjfm",
	"./writingjapaneseanimal_74_optimized.jpg": "i7Ph",
	"./writingjapaneseanimal_75_optimized.jpg": "YJpp",
	"./writingjapaneseanimal_76_optimized.jpg": "vXlA",
	"./writingjapaneseanimal_77_optimized.jpg": "fJvz",
	"./writingjapaneseanimal_78_optimized.jpg": "Gb2G",
	"./writingjapaneseanimal_79_optimized.jpg": "t8lR",
	"./writingjapaneseanimal_7_optimized.jpg": "Y9/Q",
	"./writingjapaneseanimal_80_optimized.jpg": "QF+h",
	"./writingjapaneseanimal_81_optimized.jpg": "inXr",
	"./writingjapaneseanimal_82_optimized.jpg": "XPPZ",
	"./writingjapaneseanimal_83_optimized.jpg": "hG7W",
	"./writingjapaneseanimal_84_optimized.jpg": "yEbs",
	"./writingjapaneseanimal_85_optimized.jpg": "Fffj",
	"./writingjapaneseanimal_86_optimized.jpg": "N4zG",
	"./writingjapaneseanimal_87_optimized.jpg": "7eqi",
	"./writingjapaneseanimal_88_optimized.jpg": "cG0a",
	"./writingjapaneseanimal_89_optimized.jpg": "pryn",
	"./writingjapaneseanimal_8_optimized.jpg": "YV3m",
	"./writingjapaneseanimal_90_optimized.jpg": "xxIn",
	"./writingjapaneseanimal_91_optimized.jpg": "HrJ9",
	"./writingjapaneseanimal_92_optimized.jpg": "TjRe",
	"./writingjapaneseanimal_93_optimized.jpg": "1/Gc",
	"./writingjapaneseanimal_94_optimized.jpg": "yR2Z",
	"./writingjapaneseanimal_95_optimized.jpg": "g1iE",
	"./writingjapaneseanimal_96_optimized.jpg": "fbPx",
	"./writingjapaneseanimal_97_optimized.jpg": "cxha",
	"./writingjapaneseanimal_98_optimized.jpg": "J/vp",
	"./writingjapaneseanimal_99_optimized.jpg": "UYXR",
	"./writingjapaneseanimal_9_optimized.jpg": "7P8v"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DkM8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/page ^\.\/writingjapaneseanimal_.*_optimized\.jpg$
// module id = DkM8
// module chunks = 0